import axios from 'axios';
import {DOMEN} from './domen'


export default class Service {

    constructor() {}

    sendDeals(params) {
        const url = `${DOMEN}/api/brokerparser/`;
        return axios.post(
            url,
            params,
            {
                headers: {"X-Requested-With": "XMLHttpRequest", "Content-Type": "multipart/form-data"}
            }
        )
    }

    getPortfolios() {
        return axios.get(`${DOMEN}/api/portfolio/`);
    }

    getPortfolio(pk) {
        const url = `${DOMEN}/api/portf/${pk}/?graph`;
        return axios.get(url);
    }
    getExcelPortfolio(pk){
        const url = `${DOMEN}/api/portf/${pk}/?f=xlsx`;
        return axios.get(
            url,
            {
                responseType: 'blob',
            }
        );
    }

    ClearPortfolio(pk){
        const url = `${DOMEN}/api/portf/${pk}/`;
        return axios.post(
            url,
            {
                command: 'clear',
            }
        );
    }
    getPortfolioWithoutGraph(pk) {
        const url = `${DOMEN}/api/portf/${pk}/`;
        return axios.get(url);
    }

    createPortfolio(portfolio) {
        const url = `${DOMEN}/api/portfolio/`;
        return axios.post(url, portfolio);
    }

    deletePortfolio(pk) {
        const url = `${DOMEN}/api/portfolio/${pk}/`;
        return axios.delete(url);
    }

    updatePortfolio(portfolio, pk) {
        const url = `${DOMEN}/api/portfolio/${pk}/`;
        return axios.put(url, portfolio);
    }

    updatePortfolioPatch(portfolio, pk) {
        const url = `${DOMEN}/api/portfolio/${pk}/`;
        return axios.patch(url, portfolio);
    }

    createTransaction(transaction) {
        const url = `${DOMEN}/api/transaction/`;
        return axios.post(url, transaction);
    }

    importTinkoffToken(object) {
        const url = `${DOMEN}/api/tinkoffimport/`;
        return axios.post(url, object);
    }

    tinkoffImportUpdate(portfolio) {
        const url = `${DOMEN}/api/tinkoffimportupdate/`;
        return axios.post(url, portfolio);
    }
    updateTransaction(transaction,pk) {
        const url = `${DOMEN}/api/transaction/${pk}/`;
        return axios.put(url, transaction);
    }

    deleteTransaction(transaction) {
        const url = `${DOMEN}/api/transaction/${transaction}/`;
        return axios.delete(url);
    }

    searchSecurity(str) {
        const url = `${DOMEN}/api/search/`;
        return axios.post(url, str);
    }

    getSecurity(pk) {
        const url = `${DOMEN}/api/candles/${pk}`;
        return axios.get(url);
    }

    // MCP-токены
    getMCPTokens() {
        return axios.get(`${DOMEN}/api/mcp-tokens/`);
    }

    createMCPToken(data) {
        return axios.post(`${DOMEN}/api/mcp-tokens/`, data);
    }

    updateMCPToken(id, data) {
        return axios.patch(`${DOMEN}/api/mcp-tokens/${id}/`, data);
    }

    deleteMCPToken(id) {
        return axios.delete(`${DOMEN}/api/mcp-tokens/${id}/`);
    }
}
